import React from 'react';
import { bool, shape, string } from 'prop-types';

const People = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.72361 3.55279C9.893 3.214 10.2393 3 10.618 3H13.382C13.7607 3 14.107 3.214 14.2764 3.55279L15 5H17.5C17.7761 5 18 5.22386 18 5.5V6.5C18 6.77614 17.7761 7 17.5 7H15.4653C15.8054 7.58826 16 8.2713 16 9C16 11.21 14.21 13 12 13C9.79 13 8 11.21 8 9C8 8.2713 8.19461 7.58826 8.53472 7H6.5C6.22386 7 6 6.77614 6 6.5V5.5C6 5.22386 6.22386 5 6.5 5H9L9.72361 3.55279ZM12.0004 6.89844C13.1604 6.89844 14.1004 7.83844 14.1004 8.99844C14.1004 10.1584 13.1604 11.0984 12.0004 11.0984C10.8404 11.0984 9.90039 10.1584 9.90039 8.99844C9.90039 7.83844 10.8404 6.89844 12.0004 6.89844Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 14C9.33 14 4 15.34 4 18V21H20V18C20 15.34 14.67 14 12 14ZM16 16.6466C17.243 17.1039 18.1004 17.6635 18.1004 17.9984V19.0984H16V16.6466ZM14 16.0957C13.3506 15.973 12.6714 15.8984 12.0004 15.8984C11.3291 15.8984 10.6496 15.973 10 16.0959V19.0984H14V16.0957ZM8 16.6469V19.0984H5.90039V17.9984C5.90039 17.6636 6.75738 17.1042 8 16.6469Z" fill="currentColor" />
  </svg>
);

People.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default People;
